if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    $('.sym-slides').slick();

    $('.top-content__arrow-down').click(function(e){
        e.preventDefault();
        var body = $("html, body");
        var heightWin = $(window).height() - 90;
        body.stop().animate({scrollTop: heightWin}, 500, 'swing');
    })

    $('.show-activities').click(function(event) {
        if(!$(this).hasClass('active')) {
            $('.events-quad .btn').removeClass('active');
            $(this).addClass('active');
            var target = $(this).attr('href');
            $('.activities').not(target).hide();
            $(target).fadeIn();
            $('html, body').animate({scrollTop: $(target).offset().top - $('header').height()}, 800);
        }
        return false;
    });
    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
})();